<template>
  <!-- O clique e o resto chegam pelo `$attrs`, que caem no botão: o `@click.stop.prevent` de quem usa, ou
       os `props` do slot `clear` do Vuetify (o clique de limpar, foco e `tabindex`). -->
  <v-btn class="remove-button" variant="text" icon size="x-small" :title="$tt('remove')">
    <v-icon size="x-small" icon="mdi-close"/>
  </v-btn>
</template>

<script lang="ts">
import {Component, Vue, toNative} from 'vue-facing-decorator'

/**
 * O × de tirar um valor de um campo: o de cada valor no múltiplo e o de limpar o campo de um valor só.
 *
 * Estava escrito igual no `RelSelection` e no `ChoiceInput`, e o de limpar era o do Vuetify — um círculo
 * cheio de 24px, o maior ícone do campo, fora do padrão do × da Parceria (relato do usuário). Agora os
 * campos desenham daqui.
 */
@Component({name: 'ontos-remove-button'})
class RemoveButton extends Vue {
}

export default toNative(RemoveButton)
</script>

<style scoped>
/* O × não compete com o valor: aparece apagado e ganha contraste ao se aproximar dele. */
.remove-button {
  margin-left: 2px;
  opacity: .5;
}

.remove-button:hover {
  opacity: 1;
}
</style>
